function copyToClipboard(query) {
    var copyText = document.querySelector(query);
    copyText.select();
    copyText.setSelectionRange(0, copyText.value.length);
    document.execCommand("copy");
}

function selectText(select) {
    var node = document.querySelector(select);

    if (document.body.createTextRange) {
        const range = document.body.createTextRange();
        range.moveToElementText(node);
        range.select();
    } else if (window.getSelection) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(node);
        selection.removeAllRanges();
        selection.addRange(range);
    } else {
        console.warn("Could not select text in node: Unsupported browser.");
    }
}

var copyToClipboardElements = document.getElementsByClassName("copy-to-clipboard-btn");
if (copyToClipboardElements) {
    for (var i = 0; i < copyToClipboardElements.length; i++) {
        copyToClipboardElements[i].addEventListener('click', function(){
            var query = this.getAttribute("data-query");
            copyToClipboard(query);
            var select = this.getAttribute("data-select");
            if (select) {
                selectText(select);
            }
        }, false);
    }
}

document.addEventListener("DOMContentLoaded", function(event) {
    var openers = document.getElementsByClassName("open-chat");
    for (var index = 0; index < openers.length; index++) {
        openers[index].addEventListener("click", function(){
            if (typeof $crisp !== 'undefined') {
                if ($crisp.is("chat:opened")) {
                    $crisp.push(['do', 'chat:close']);
                } else {
                    $crisp.push(['do', 'chat:open']);
                }
            }
            if (typeof Tawk_API !== 'undefined') {
                Tawk_API.toggle();
            }
            if (typeof drift !== 'undefined') {
                drift.openChat();
            }
            if (typeof zE !== 'undefined') {
                zE('webWidget', 'toggle');
            }
            if (typeof window.Beacon !== 'undefined') {
                window.Beacon('toggle');
            }
        });
    }
});
